import config from '../config';

import {
    loadClockTaskById,
    loadProjectById,
    startClockByTaskId,
    stopClockByTaskId,
    getProjectsByUserId,
    getProjectsByUserIdFailed,
} from '../actions/taskClock';
import { addNotification as notify } from 'reapop';
import fetch from 'cross-fetch';
import store from 'store2';
import { push } from 'react-router-redux';

export function fetchClockTaskById(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/taskClock/getTask/${id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(loadClockTaskById({ clockTask: json }));
          }
        })
    }
  }
};

export function fetchProjectById(id) {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        return fetch(`${config.apiEndpoint}/taskClock/getProject/${id}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if (json) {
              dispatch(loadProjectById({ clockTask: json }));
            }
          })
      }
    }
};

export function startClockByTask(data) {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        return fetch(`${config.apiEndpoint}/taskClock/startClock`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if(json.code === 410) {
              dispatch(notify({
                title: json.title,
                message: json.detail,
                status: 'warning',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            }
            else {
              if (json) {
                dispatch(startClockByTaskId({ clockTask: {...json, task_id: data.task_id, item_id: data.item_id} }));
              }
            }
          })
      }
    }
};

export function stopClockByTask(data) {
    return (dispatch) => {
      const userAuth = store.get('user');
      if (userAuth && userAuth.api_token) {
        return fetch(`${config.apiEndpoint}/taskClock/stopClock`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `bearer ${userAuth.api_token}`
            },
            credentials: 'same-origin'
          })
          .then((response) => {
            return response.json();
          })
          .then(json => {
            if(json.code === 410) {
              dispatch(notify({
                title: json.title,
                message: json.detail,
                status: 'warning',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            } else {
              if (json) {
                dispatch(stopClockByTaskId({ clockTask: {...json, task_id: data.task_id, item_id: data.item_id} }));
              }
            }
          })
      }
    }
};

export function getList(taskId) {
  return dispatch => {
    const userAuth = store.get('user');
    const url = taskId ? `${config.apiEndpoint}/taskClock/${taskId}` : `${config.apiEndpoint}/taskClock`;
    return fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
      .then((response) => {
        return response.json();
      })
      .then(json => {
          dispatch(getProjectsByUserId(json));
      })
  }
};



// WEBPACK FOOTER //
// ./src/api/taskClock.js